import type { OpenPositionCustomerAggregate } from "@/common/api/open-position/use-open-position-customer-aggregate-search.query";
import { getCustomerDisplayName } from "@/components/data-table/predefined/customer-table/_helpers/get-customer-display-name";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import { EmptyValue } from "@/components/ui/empty-value";
import i18next from "i18next";
import { createAggregateMetricColumns } from "./aggregate-metric-columns";

export type CustomerAggregateRow = OpenPositionCustomerAggregate & { uuid: string };

export const toCustomerAggregateRow = (aggregate: OpenPositionCustomerAggregate): CustomerAggregateRow => ({
  ...aggregate,
  uuid: aggregate.customer.uuid,
});

const metricColumns = createAggregateMetricColumns<CustomerAggregateRow>();

export const customerAggregateColumns = {
  name: {
    id: "name",
    size: 260,
    enableSorting: true,
    header: () => i18next.t("fia:Customer"),
    accessorFn: (row: CustomerAggregateRow) => row.customer,
    cell: (info) => getCustomerDisplayName(info.getValue()) || <EmptyValue />,
  } as ImplementedAccessorColumnDef<CustomerAggregateRow, CustomerAggregateRow["customer"]>,
  ...metricColumns,
};
